/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGlassChampagne = createReactComponent("outline", "glass-champagne", "IconGlassChampagne", [["path", { "d": "M9 21h6", "key": "svg-0" }], ["path", { "d": "M12 16v5", "key": "svg-1" }], ["path", { "d": "M12 5m-4 0a4 2 0 1 0 8 0a4 2 0 1 0 -8 0", "key": "svg-2" }], ["path", { "d": "M8 5c0 6.075 1.79 11 4 11s4 -4.925 4 -11", "key": "svg-3" }]]);

export { IconGlassChampagne as default };
//# sourceMappingURL=IconGlassChampagne.mjs.map
